import { render, staticRenderFns } from "./AuditoriasAcesso.vue?vue&type=template&id=7bc5b80f&scoped=true"
import script from "./AuditoriasAcesso.vue?vue&type=script&lang=js"
export * from "./AuditoriasAcesso.vue?vue&type=script&lang=js"
import style0 from "./AuditoriasAcesso.vue?vue&type=style&index=0&id=7bc5b80f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc5b80f",
  null
  
)

export default component.exports